import { memo } from 'react';

import { Flex, Heading, Loading, Text } from '@/components/core';
import { ScaffoldAgentStatus, useDots } from '@/hooks';

import { Step } from './Step';

type SetupAgentStepProps = {
  status: ScaffoldAgentStatus;
  hasTrigger: boolean;
  hasExport: boolean;
};

const ISetupAgentStep = ({ status, hasTrigger, hasExport }: SetupAgentStepProps) => {
  const dots = useDots();

  let message = 'Creating agent';
  if (!status.model.isSuccess || status.model.isPending) {
    message = 'Initializing AI model';
  } else if (!status.validation.isSuccess || status.validation.isPending) {
    message = 'Enabling human-in-the-loop';
  } else if (hasTrigger && !status.trigger.isSuccess) {
    message = 'Configuring trigger';
  } else if (hasExport && !status.export.isSuccess) {
    message = 'Configuring export';
  }

  return (
    <Step className="p-lg w-130 gap-2 rounded-xl py-18 shadow-xl">
      <Loading size="sm" variant="primary" />
      <Flex col className="gap-xs items-center">
        <Heading size="md">Setting up your agent</Heading>
        <Text className="whitespace-pre">
          {message} {dots}
        </Text>
      </Flex>
    </Step>
  );
};

export const SetupAgentStep = memo(ISetupAgentStep) as typeof ISetupAgentStep;
